import { createSlice } from '@reduxjs/toolkit';
import { startListening } from '../listenerMiddleware';
import { getExtratos } from '../../services/planos';

const initialState = {
    items: [],
    loading: false,
    error: '',
};

const opcoesExtratoSlice = createSlice({
    name: 'opcoesExtrato',
    initialState,
    reducers: {
        itemsMenuLoad(state) {
            state.loading = true;
            state.error = '';
        },
        itemsExtratoSuccess(state, action) {
            state.items = action.payload;
            state.loading = false;
            state.error = '';
        },
        itemsExtratoError(state, action) {
            state.loading = false;
            state.error = action.payload;
        }
    }
});

export const {
    itemsMenuLoad,
    itemsExtratoSuccess,
    itemsExtratoError
} = opcoesExtratoSlice.actions;

export default opcoesExtratoSlice.reducer;

startListening({
    actionCreator: itemsMenuLoad,
    effect: async (action, listenerApi) => {
        try {
            const response = await getExtratos();
            const { data, messages } = response;

            if (messages)
                listenerApi.dispatch(itemsExtratoError(messages));
            else
                listenerApi.dispatch(itemsExtratoSuccess(data));
        } catch (error) {
            listenerApi.dispatch(itemsExtratoError(error.messages));
        }
    }
});

startListening({
    actionCreator: itemsExtratoError,
    effect: async (action) => {
        console.log('Erro ao carregar os extratos !', action.payload);
    }
});